/* import __COLOCATED_TEMPLATE__ from './page-wrapper.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './page-wrapper.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsitePageWrapper extends Component {}
